import type { Config, Event } from '@bugsnag/core';

import { environment } from '@environment';

export const bugsnagConfig: Config = {
  releaseStage: environment.platform,
  appVersion: environment.version,
  apiKey: environment.bugsnag.key,
  autoTrackSessions: false,
  metadata: {
    extras: {
      country: environment.i18n.country,
      lang: environment.i18n.lang,
      locale: environment.i18n.locale,
    },
  },
  onError: (event: Event) => {
    // user tying to access old app chunks
    if (event.originalError.name === 'ChunkLoadError') {
      return false;
    }

    if (event.originalError.name === 'HttpErrorResponse') {
      if (event.originalError.status === 403 || event.originalError.status === 404) {
        return false;
      }

      // Errors due to cors, adblock or network failures
      if (event.originalError.message.toLowerCase().includes('0 Unknown Error'.toLowerCase())) {
        return false;
      }
    }

    if (event.originalError.name === 'ReferenceError') {
      if (
        event.originalError.message.toLowerCase().includes('__AutoFillPopupClose__'.toLowerCase()) ||
        event.originalError.message.toLowerCase().includes('SCAutofillBridge'.toLowerCase())
      ) {
        return false;
      }
    }

    if (event.originalError.name === 'TypeError') {
      // Errors from widgets or to web-metrics-api failed fetch requests due to network failures
      if (event.originalError.message === 'NetworkError when attempting to fetch resource') {
        return false;
      }

      // Errors from failed fetch requests of consent and web metrics API
      const requestEventId = (event.breadcrumbs ?? []).findIndex((breadcrumb) => breadcrumb.type === 'request');
      const requestEvent = (event.breadcrumbs ?? [])[requestEventId];
      if (
        requestEvent &&
        requestEvent.message === 'fetch() error' &&
        (requestEvent.metadata['request']?.includes('_api/web-metrics-api') ||
          requestEvent.metadata['request']?.includes(`https://consent.${environment.api.domain}/v2/consent/`))
      ) {
        return false;
      }
    }

    return true;
  },
};
